import { get } from 'utils/api';

export const getAllModule = (data) => {
  return get(`/modules`, data);
};

export const module = {
  getAllModule,
};
